import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class BQRequestService {

  url: string = 'https://us-central1-bancointernacional.cloudfunctions.net/HTTP-Tests'
  url2: string = 'https://us-central1-bancointernacional.cloudfunctions.net/Graphic_hist'
  url3: string = 'https://us-central1-bancointernacional.cloudfunctions.net/BD_RegLarge'
  urlC: string = 'https://us-central1-bancointernacional.cloudfunctions.net/CommandSender'
  urlT: string = 'https://us-central1-bancointernacional.cloudfunctions.net/liveFeedMT'
  urlUPS: string = 'https://us-central1-bancointernacional.cloudfunctions.net/livefeedUPS'
  urlIndices: string = 'https://us-central1-bancointernacional.cloudfunctions.net/IndexesRequest'
  urlDaily: string = 'https://us-central1-bancointernacional.cloudfunctions.net/DailyRequest'
  urlDailyYear: string = 'https://us-central1-bancointernacional.cloudfunctions.net/DailyRequestYear'
  urlConsumerDaily: string = 'https://us-central1-bancointernacional.cloudfunctions.net/ConsumerDailyRequest'
  urlConsumerMonthly: string = 'https://us-central1-bancointernacional.cloudfunctions.net/IndexesRequestConsumer'
  urlDailyParamRequest: string = 'https://us-central1-bancointernacional.cloudfunctions.net/ConsumerDailyRequest-WParams'
  urlConsumerParamRequest: string= 'https://us-central1-bancointernacional.cloudfunctions.net/IndexesRequestConsumer-WParams'
  urlIOParametersUpdate: string= 'https://us-central1-gentecsandbox.cloudfunctions.net/sendIOConfig'
  //url: string = '/HTTP-Tests'
  constructor(private http: HttpClient) { }

  setupFirebase(PID){
    this.url = "https://us-central1-"+PID+".cloudfunctions.net/HTTP-Tests"
    this.url2 = 'https://us-central1-'+PID+'.cloudfunctions.net/Graphic_hist'
    this.url3 = 'https://us-central1-'+PID+'.cloudfunctions.net/BD_RegLarge'
    this.urlC = 'https://us-central1-'+PID+'.cloudfunctions.net/CommandSender'
    this.urlT = 'https://us-central1-'+PID+'.cloudfunctions.net/liveFeedMT'
    this.urlUPS = 'https://us-central1-'+PID+'.cloudfunctions.net/livefeedUPS'
    this.urlIndices = 'https://us-central1-'+PID+'.cloudfunctions.net/IndexesRequest'
    this.urlDaily = 'https://us-central1-'+PID+'.cloudfunctions.net/DailyRequest'
    this.urlDailyYear = 'https://us-central1-'+PID+'.cloudfunctions.net/DailyRequestYear'
    this.urlConsumerDaily = 'https://us-central1-'+PID+'.cloudfunctions.net/ConsumerDailyRequest'
    this.urlConsumerMonthly = 'https://us-central1-'+PID+'.cloudfunctions.net/IndexesRequestConsumer'
    this.urlDailyParamRequest = 'https://us-central1-'+PID+'.cloudfunctions.net/ConsumerDailyRequest-WParams'
    this.urlConsumerParamRequest = 'https://us-central1-'+PID+'.cloudfunctions.net/IndexesRequestConsumer-WParams'
    this.urlIOParametersUpdate = 'https://us-central1-'+PID+'.cloudfunctions.net/sendIOConfig'
  }


  sendRequest(dev_name, dev_type, Zone, City, Office){
    let  body = {
                  devName: dev_name,
                  devType: dev_type,
                  zone: Zone,
                  city: City,
                  office: Office
                }
    
    return this.http.post(this.url, body);    
    /*
    const headers = new HttpHeaders()
        .set("Access-Control-Allow-Origin", "*")
        .set("Access-Control-Allow-Methods", "POST, GET, OPTIONS")
        .set("Access-Control-Allow-Headers", "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers")
        //.set('cache-control', 'no-cache')
        .set('content-type', 'application/json')
        //.set('postman-token', 'b408a67d-5f78-54fc-2fb7-00f6e9cefbd1');

    const body = {
        devName: dev_name,
        devType: dev_type,
        zone: Zone,
        city: City,
        office: Office
    }

    return this.http.post(this.url, body, { headers: headers}) */
  }

  sendMTRequest(dev_name, dev_type, Zone, City, Office){
      let  body = {
                    devName: dev_name,
                    devType: dev_type,
                    zone: Zone,
                    city: City,
                    office: Office
                  }
      
      return this.http.post(this.urlT, body);    
  }

  sendIndexesRequest(){
    let  body = {"projName": "JPAQR"}
    
    return this.http.post(this.urlIndices, body);    
  }

  sendDailyRequest(){
    let  body =  {"projName": "JPAQR"}
      
      return this.http.post(this.urlDaily, body);   
  }

  sendDailyRequestParams(date: string){
    let  body =  {"projName": "JPAQR", "Month": date}
      
      return this.http.post(this.urlDailyParamRequest, body);   
  }

  sendDailyRequestYear(start, end){
    let  body =  {"start": start, "end": end}
      
      return this.http.post(this.urlDailyYear, body);   
  }

  sendDailyConsumersRequest(){
    let  body =  {"projName": "JPAQR"}
      
      return this.http.post(this.urlConsumerDaily, body);   
  }

  sendConsumersRequest(){
    let  body = {"projName": "JPAQR"}
    
    return this.http.post(this.urlConsumerMonthly, body);    
    
  }

  sendDConsumerRequestParams(date: string){
    let  body =  {"projName": "JPAQR", "Month": date}
      
      return this.http.post(this.urlConsumerParamRequest, body);   
  }

  sendUPSRequest(dev_name, dev_type, Zone, City, Office){
    let  body = {
                  devName: dev_name,
                  devType: dev_type,
                  zone: Zone,
                  city: City,
                  office: Office
                }
    
    return this.http.post(this.urlUPS, body);    
  }

  sendRequestGraph(dev_name, dev_type, Zone, City, Office){
    
    let  body = {
                  devName: dev_name,
                  devType: dev_type,
                  zone: Zone,
                  city: City,
                  office: Office
                }
    
    return this.http.post(this.url2, body);
  }

  sendIoTCommand(registry, devName, value){
    let  body = {
                  "devName": devName,
                  "registry": registry,
                  "command": {"command":"toggleState", "body": value}
                }

    return this.http.post(this.urlC, body);
  }

  sendIOUpdate(registry, devName, leva1, leva2){
    let leva3 = {"days": 0, "timeIn": 65535, "timeOut": 65535};
    let  body = {
      "devName": devName,
      "registry": registry,
      "Leva1": leva1,
      "Leva2": leva2,
      "Leva3": leva3
    }

    return this.http.post(this.urlIOParametersUpdate, body);
  }

  sendLargeRequestGraph(dev_name, dev_type, Zone, City, Office, telem, startD, endD){
    let  body = {
                  devName: dev_name,
                  devType: dev_type,
                  zone: Zone,
                  city: City,
                  office: Office,
                  telem: telem,
                  startdate: startD,
                  enddate: endD
                }
    return this.http.post(this.url3, body);
  }
  
}
